import { ReactNode } from "react";
import { useFormikContext, useField } from "formik";

import NumberInputWrapper from "../../common/NumberInput/NumberInputWrapper";
import FormikErrorMessage from "../FormikErrorMessage";

import { FieldTypes, renderFormLabel } from "../FormikFormLine/constants";
import { ToggleDirection } from "../../common/NumberInput/constants";
import * as formLineStyles from "../FormikFormLine/FormikFormLineStyles";
import * as styledElements from "./FormikNumberInputStyles";

const FormikNumberInput = ({
  name,
  disabled,
  min,
  max,
  label,
  labelComponent,
  autoFocus,
  step,
}: {
  name: string;
  disabled?: boolean;
  min?: number;
  max?: number;
  label?: string;
  labelComponent?: ReactNode;
  autoFocus?: boolean;
  step?: number;
}) => {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(name);
  const definitelyStep = step === undefined ? 1 : step;

  const handleToggle = (direction: ToggleDirection) => {
    const value = field.value as number;
    void setFieldValue(
      name,
      direction == ToggleDirection.UP
        ? value + definitelyStep
        : value - definitelyStep,
    );
  };

  return (
    <formLineStyles.Container>
      {renderFormLabel(name, label, labelComponent)}
      <NumberInputWrapper
        disabled={disabled || false}
        handleToggle={handleToggle}
      >
        <styledElements.StyledField
          autoFocus={autoFocus}
          type={FieldTypes.number}
          step={"any"}
          name={name}
          min={min}
          max={max}
          disabled={disabled}
        />
      </NumberInputWrapper>
      <FormikErrorMessage name={name} />
    </formLineStyles.Container>
  );
};

export default FormikNumberInput;
